import React, { useMemo } from 'react';
import { Trans } from 'react-i18next';

interface LegalTextComponentProps {
  market: string;
  modelYear?: number;
}

const LegalText: React.FC<LegalTextComponentProps> = ({ market, modelYear }) => {
  const translationKey = useMemo(() => {
    if (market.includes('ca')) return 'vehiclePricingBar.dealerListPrice.dealerListPriceLegalText';
    if (market === 'us' && (modelYear === 2025 || modelYear === 2026))
      return 'vehiclePricingBar.dealerListPrice.msrpLegalTextUSA-2025';

    if (market === 'us') return 'vehiclePricingBar.dealerListPrice.msrpLegalTextUSA';

    // market === 'usuc'
    return 'vehiclePricingBar.dealerListPrice.dealerPriceLegalText';
  }, [market, modelYear]);

  return (
    <Trans
      i18nKey={translationKey}
      // the global reset css imported in several feature apps
      // contains globally applied oppinionated styling
      components={{ bold: <span style={{ fontWeight: 'bold' }} /> }}
    />
  );
};

export default LegalText;
